export const pricerContentTypeOptions = [
  { value: "pre_test_and_post_test", label: " Pre-test and/or Post-test" },
  { value: "concept_test", label: " Concept test" },
  { value: "ua_consomation_habits", label: " U&A - Consumption patterns" },
  { value: "ua_other", label: " U&A - Other" },
  { value: "opinion_society", label: " Opinion poll/Society" },
  { value: "market_image_notoriety", label: " Market research/brand awareness" },
  { value: "user_satisfaction", label: " Customer satisfaction survey" },
  { value: "other", label: " Other" },
];
export const pricerContentTopicOptions = [
  { value: "automotive", label: "Automotive" },
  { value: "business", label: "Business" },
  { value: "cosmetic_personal_care", label: "Cosmetics, Personal Care" },
  { value: "family_child_parenting", label: "Family, Child, Parenting" },
  { value: "fashion", label: "Fashion" },
  { value: "finance_banking_insurance", label: "Finance, Banking, Insurance" },
  { value: "food", label: "Food" },
  { value: "government_politics", label: "Government, Politics" },
  { value: "health", label: "Health" },
  { value: "public", label: "Public" },
  { value: "real_estate", label: "Real Estate" },
  { value: "recreation", label: "Recreation (sports, travel, media…)" },
  { value: "shopping_retail_ecommerce", label: "Shopping, Retail, E-commerce" },
  { value: "transportation", label: "Transportation" },
  { value: "other", label: "Other" },
];
export const pricerTargetTypeOptions = [
  { value: "brand_consumers", label: "Brand consumers" },
  { value: "shop_customers", label: "Shop customers" },
  { value: "hobbies", label: "Hobbies" },
  { value: "parents", label: "Parents" },
  { value: "other_ir_greater_than_25", label: "Other - IR > 25%" },
  { value: "other_ir_less_than_25", label: "Other - IR < 25%" },
  { value: "hairdressers", label: "Hairdressers" },
  { value: "truck_drivers", label: "Truck drivers" },
  { value: "craftsmen", label: "Craftsmen" },
  { value: "restaurant_owners", label: "Restaurant owners" },
  { value: "midwives", label: "Midwives" },
  { value: "nurses", label: "Nurses" },
  { value: "life_assistant", label: "Life assistant" },
  { value: "other", label: "Other" },
];
const FIRST_HISTO_YEAR = 2019;
const currentYear = new Date().getFullYear();
export const yearOptions = Array.from({ length: currentYear - FIRST_HISTO_YEAR + 1 }, (_, index) => {
  const year = String(currentYear - index);
  return { value: year, label: year };
});
export const monthsOptions = [
  { value: "01", label: "Janvier" },
  { value: "02", label: "Février" },
  { value: "03", label: "Mars" },
  { value: "04", label: "Avril" },
  { value: "05", label: "Mai" },
  { value: "06", label: "Juin" },
  { value: "07", label: "Juillet" },
  { value: "08", label: "Août" },
  { value: "09", label: "Septembre" },
  { value: "10", label: "Octobre" },
  { value: "11", label: "Novembre" },
  { value: "12", label: "Décembre" },
];
